Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var WPGHeadingBlock = function WPGHeadingBlock(props) {
  var innerHTML = props.innerHTML;
  return React.createElement("div", {
    className: "wpg-block wpg-b_heading",
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  });
};

exports.default = WPGHeadingBlock;